<template>
    <div>
        <basic-container>
            <!------------------搜索栏-------------- -->
            <div class="query-form-wrap">
                <div class="query-form-wrap-left">
                    <el-form :inline="true" :model="searchForm" :size="formSize">
                        <!-- 场景搜索 -->
                        <el-form-item label-width="2.1333rem">
                            <el-select :size="small" clearable v-model="searchForm.castFunType" placeholder="请选择投屏方式">
                                <el-option v-for="item in useWrCloudSelect" :label="item.label" :key="item.id"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <!-- 投屏内容 -->
                        <el-form-item :span="10">
                            <el-select :size="small" clearable v-model="searchForm.castCxtType" placeholder="请选择投屏内容">
                                <el-option v-for="item in castCxtTypeSelect" :key="item.id" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <!-- 反诈标签 0-否 1-是-->
                        <el-form-item>
                            <el-select :size="small" clearable v-model="searchForm.fraudLabel" placeholder="反诈标签">
                                <el-option label="否" key="0" value="0"> </el-option>
                                <el-option label="是" key="1" value="1"> </el-option>
                            </el-select>
                        </el-form-item>
                        <!-- 0-正常 1-审核提醒 2-审核阻断 3-系统阻断 4-忽略 -->
                        <el-form-item>
                            <el-select :size="small" clearable v-model="searchForm.handleState" placeholder="处理状态">
                                <el-option label="正常" key="0" value="0"> </el-option>
                                <el-option label="审核提醒" key="1" value="1"> </el-option>
                                <el-option label="审核阻断" key="2" value="2"> </el-option>
                                <el-option label="系统阻断" key="3" value="3"> </el-option>
                                <el-option label="忽略" key="4" value="4"> </el-option>
                            </el-select>
                        </el-form-item>
                        <!-- 涉政标签：0-否 1-是 -->
                        <el-form-item>
                            <el-select :size="small" clearable v-model="searchForm.politicsLabel" placeholder="涉政标签">
                                <el-option label="否" key="0" value="0"> </el-option>
                                <el-option label="是" key="1" value="1"> </el-option>
                            </el-select>
                        </el-form-item>
                        <!-- 房间码搜索 -->
                        <el-form-item>
                            <el-input clearable v-model="searchForm.roomCode" placeholder="房间码"></el-input>
                        </el-form-item>
                        <!-- 收端用户id -->
                        <el-form-item>
                            <el-input clearable v-model="searchForm.receiverUserId" placeholder="收端用户id"></el-input>
                        </el-form-item>
                        <!-- 收端设备uid -->
                        <el-form-item>
                            <el-input clearable v-model="searchForm.receiverUid" placeholder="收端设备uid"></el-input>
                        </el-form-item>
                        <!-- 发端设备uid -->
                        <el-form-item>
                            <el-input clearable v-model="searchForm.senderUid" placeholder="发端设备uid"></el-input>
                        </el-form-item>
                        <!-- 发端用户id -->
                        <el-form-item>
                            <el-input clearable v-model="searchForm.senderUserId" placeholder="发端用户id"></el-input>
                        </el-form-item>
                        <!-- taskId -->
                        <el-form-item>
                            <el-input clearable v-model="searchForm.taskId" placeholder="taskId"></el-input>
                        </el-form-item>
                        <!-- 涉恐标签：0-否 1-是 -->
                        <el-form-item>
                            <el-select :size="small" clearable v-model="searchForm.terrorLabel" placeholder="涉恐标签">
                                <el-option label="否" key="0" value="0"> </el-option>
                                <el-option label="是" key="1" value="1"> </el-option>
                            </el-select>
                        </el-form-item>
                        <!-- 涉黄标签：0-否 1-是 -->
                        <el-form-item>
                            <el-select :size="small" clearable v-model="searchForm.yellowLabel" placeholder="涉黄标签">
                                <el-option label="否" key="0" value="0"> </el-option>
                                <el-option label="是" key="1" value="1"> </el-option>
                            </el-select>
                        </el-form-item>
                        <!-- {{ cascaderOptions }} -->
                        <el-cascader size="small" placeholder="城市选择" :options="cascaderOptions"
                            v-model="searchForm.receiverProvince" :props="{ value: 'label', checkStrictly: true }" />

                        <!-- 收端类型:0-安卓 1-ios 2-tv 3-pc 4-mac 5-h5手机 6-h5电脑 -->
                        <el-form-item label-width="2.1333rem" style="margin-left: 10px">
                            <el-select :size="small" clearable v-model="searchForm.receiverClientType" placeholder="收端类型">
                                <el-option label="安卓" key="0" value="0"> </el-option>
                                <el-option label="ios" key="1" value="1"> </el-option>
                                <el-option label="tv" key="2" value="2"> </el-option>
                                <el-option label="pc" key="3" value="3"> </el-option>
                                <el-option label="mac" key="4" value="4"> </el-option>
                                <el-option label="h5手机" key="5" value="5"> </el-option>
                                <el-option label="h5电脑" key="6" value="6"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-select :size="small" clearable v-model="searchForm.differentProvinceFlag" placeholder="区域">
                                <el-option label="正常" key="0" value="0"> </el-option>
                                <el-option label="跨省" key="1" value="1"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-date-picker v-model="searchForm.startCreateTime" format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd" start-placeholder="记录创建开始日期" end-placeholder="记录创建结束日期"
                                type="daterange" placeholder="记录创建日期范围">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item :span="20">
                            <el-button icon="el-icon-search" type="primary" @click="handleSearch()"
                                v-auth="'SECURITY_RISKRESULT_SEARCH'">搜索</el-button>
                            <el-button icon="el-icon-delete" @click="handleClear()">清空</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

            <!-- ---------------表单 ------------------------>
            <div>
                <!-- ---------------avue-curd --------------------->
                <avue-crud ref="riskList" :option="option" :data="list" :page.sync="page" :table-loading="loading"
                    @on-load="onLoad" @selection-change="selectionChange" :search.sync="search" @row-cancel="handleCancel()"
                    @size-change="sizeChange" @current-change="currentChange" @search-change="onLoad"
                    @refresh-change="refresh">
                    <template slot-scope="{ type, size, row, index }" slot="menu">
                        <el-button :size="size" :type="type" @click="detail(row, index)"
                            v-auth="'SECURITY_RISKRESULT_VIEW'">详情</el-button>
                        <el-button v-show="row.handleState === '0' || row.handleState === '1'" :size="size" :type="type"
                            @click="handleStop(row.id)" v-auth="'SECURITY_RISKRESULT_BLOCK'">阻断</el-button>
                        <el-button v-show="row.handleState === '0' || row.handleState === '1'" :size="size" :type="type"
                            @click="handleIngore(row.id, index)" v-auth="'SECURITY_RISKRESULT_IGNORE'">忽略</el-button>
                        <!-- <el-button v-show="row.state === '正常投屏' && row.riskLevel === 'level_2'" :size="size" :type="type"
                            @click="detail(row, index)">解封</el-button> -->
                    </template>
                    <template slot="originalUrl" slot-scope="scope">
                        <el-button v-if="scope.row.originalUrl" type="text" size="small" icon="el-icon-document-copy"
                            v-clipboard:copy="scope.row.originalUrl" @click="copyTip"></el-button>&nbsp;
                        <span>{{ scope.row.originalUrl }}</span>
                    </template>
                    <!-- 备注 -->
                    <template slot="remark" slot-scope="scope">
                        <el-button v-if="scope.row.remark" type="text" size="small" icon="el-icon-document-copy"
                            v-clipboard:copy="scope.row.remark" @click="copyTip"></el-button>&nbsp;
                        <span>{{ scope.row.remark }}</span>
                    </template>
                </avue-crud>
            </div>

            <!-- -------------- 详情对话框------------------>
            <el-dialog title="详情"
                       :modal-append-to-body="false"
                       :visible.sync="detailDialog" width="90%"
                       :before-close="closeDialog"
                       :close-on-press-escape = false
                       :close-on-click-modal  = false
                       >
                <!-- <h3>投屏时间: &nbsp;&nbsp;&nbsp;&nbsp;{{ screenTime }}</h3>
                <h3>管控时间: &nbsp;&nbsp;&nbsp;&nbsp;{{ controlTime }}</h3> -->
                <!------- -------------管控信息-------------- -------->
                <!-- //^ ^--------------风控信息-------------^ ^ -->
                <h3>风控信息</h3>
                <el-table :data="tableData" border style="width: 100%;overflow: auto;">
                    <el-table-column prop="fraudLabel" label="反诈标签">
                        <template slot-scope="scope">
                            <span v-if="scope.row.fraudLabel === '0'">否</span>
                            <span v-else>是</span>
                        </template>
                    </el-table-column>
                    <!-- 反诈评分等级	 -->
                    <el-table-column prop="fraudRiskLevel" label="反诈评分等级">
                    </el-table-column>
                    <!-- 反诈风控分数	 -->
                    <el-table-column prop="fraudRiskScore" label="反诈风控分数">
                    </el-table-column>
                    <!-- 涉政标签 -->
                    <el-table-column prop="politicsLabel" label="涉政标签">
                        <template slot-scope="scope">
                            <span v-if="scope.row.politicsLabel === '0'">否</span>
                            <span v-else>是</span>
                        </template>
                    </el-table-column>
                    <!-- 涉政评分等级	 -->
                    <el-table-column prop="politicsRiskLevel" label="涉政评分等级">
                    </el-table-column>
                    <!-- 涉政风控分数	 -->
                    <el-table-column prop="politicsRiskScore" label="涉政风控分数">
                    </el-table-column>
                    <!-- 涉恐标签 -->
                    <el-table-column prop="terrorLabel" label="涉恐标签">
                        <template slot-scope="scope">
                            <span v-if="scope.row.terrorLabel === '0'">否</span>
                            <span v-else>是</span>
                        </template>
                    </el-table-column>
                    <!-- 涉恐评分等级	 -->
                    <el-table-column prop="terrorRiskLevel" label="涉恐评分等级">
                    </el-table-column>
                    <!-- 涉恐风控分数	 -->
                    <el-table-column prop="terrorRiskScore" label="涉恐风控分数">
                    </el-table-column>
                    <!-- 涉黄标签 -->
                    <el-table-column prop="yellowLabel" label="涉黄标签">
                        <template slot-scope="scope">
                            <span v-if="scope.row.yellowLabel === '0'">否</span>
                            <span v-else>是</span>
                        </template>
                    </el-table-column>
                    <!-- 涉黄评分等级 -->
                    <el-table-column prop="yellowRiskLevel" label="涉黄评分等级">
                    </el-table-column>
                    <!-- 涉黄风控分数 -->
                    <el-table-column prop="yellowRiskScore" label="涉黄风控分数">
                    </el-table-column>
                    <el-table-column prop="taskId" label="TaskID"> </el-table-column>
                </el-table>
                <!-- //^ ^--------------房间信息-------------^ ^ -->
                <h3>房间信息</h3>
                <h4>共有信息</h4>
                <el-table :data="tableData" border style="width: 100%;overflow: auto;">
                    <el-table-column prop="castFunType" label="投屏方式" width="80">
                        <template slot-scope="scope">
                            {{ { 1: "局域网", 2: "公网" }[+scope.row.castFunType] }}
                        </template>
                    </el-table-column>
                    <!-- 投屏内容 -->
                    <el-table-column prop="castCxtType" label="投屏内容" width="80">
                        <template slot-scope="scope">
                            <!-- 1-镜像 2-推送 3-云桌面 4-音频文件 5-图片文件 6-其他 7-好友分享-->
                            {{ { 1: "镜像", 2: "推送", 3: "云桌面", 4: "音频文件", 5: "图片文件", 6: "其他", 7: "好友分享" }[+scope.row.castCxtType] }}
                        </template>
                    </el-table-column>
                    <!-- 处理状态 -->
                    <el-table-column prop="handleState" label="处理状态" width="80">
                        <template slot-scope="scope">
                            {{ { 0: "正常", 1: "审核提醒", 2: "审核阻断", 3: "系统阻断", 4: "忽略" }[+scope.row.handleState] }}
                        </template>
                    </el-table-column>
                    <!-- 厂商 1-网易 2-即构 3-腾讯-->
                    <el-table-column prop="senderBrand" label="厂商" width="80">
                        <template slot-scope="scope">
                            {{ { 1: "网易", 2: "即构", 3: "腾讯" }[+scope.row.senderBrand] }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="uid" label="UID" width="180">
                    </el-table-column>
                    <el-table-column prop="mirrorStartTime" label="投屏开始时间">
                    </el-table-column>
                    <el-table-column prop="endTime" label="投屏结束时间">
                    </el-table-column>
                    <el-table-column prop="roomCode" label="房间码"> </el-table-column>
                    <el-table-column prop="uuid" label="用户ID">
                        <template slot-scope="scope">
                            <span style="color: red">{{ scope.row.uuid }}</span>
                            &nbsp;&nbsp;&nbsp;
                            <!-- <a v-if="scope.row.state === '3'"
                                style="cursor: pointer;color: #409EFF;text-decoration: underline;" size="small"
                                @click="unlockControl(scope.row)">解除管控</a>
                            <span v-else style="color: gray;text-decoration: underline;">已解除</span> -->
                        </template>
                    </el-table-column>
                    <el-table-column prop="state" label="投屏状态"> </el-table-column>

                </el-table>
                <h4>收端信息</h4>
                <el-table :data="tableUserDetail.receivers" border style="width: 100%;overflow: auto;">
                    <!-- 收端appId -->
                    <el-table-column prop="appId" label="收端appId">
                    </el-table-column>
                    <!-- 收端国籍 -->
                    <el-table-column prop="nation" label="收端国籍">
                    </el-table-column>
                    <!-- 收端省份 -->
                    <el-table-column prop="province" label="收端省份">
                    </el-table-column>
                    <!-- 收端城市 -->
                    <el-table-column prop="city" label="收端城市">
                    </el-table-column>
                    <!-- 收端县区 -->
                    <el-table-column prop="county" label="收端县区">
                    </el-table-column>
                    <!-- 收端ip	 -->
                    <el-table-column prop="ip" label="收端ip">
                    </el-table-column>
                    <!-- 收端类型	 -->
                    <!-- :0-安卓 1-ios 2-tv 3-pc 4-mac 5-h5手机 6-h5电脑 -->
                    <el-table-column prop="clientType" label="收端类型">
                        <template slot-scope="scope">
                            {{ {
                                0: "安卓", 1: "ios", 2: "tv", 3: "pc", 4: "mac", 5: "h5手机", 6: "h5电脑"
                            }[+scope.row.receiverClientType] }}
                        </template>
                    </el-table-column>
                    <!-- 收端设备uid -->
                    <el-table-column prop="uid" label="收端设备uid">
                    </el-table-column>
                    <!-- 收端用户id -->
                    <el-table-column prop="userId" label="收端用户id">
                    </el-table-column>
                    <el-table-column prop="wifiName" label="收端wifi名称">
                    </el-table-column>
                    <el-table-column prop="name" label="收端名称">
                    </el-table-column>
                    <el-table-column prop="userTag" label="收端用户标签">
                    </el-table-column>
                    <el-table-column prop="deviceTag" label="收端设备标签">
                    </el-table-column>
                </el-table>
                <h4>发端信息</h4>
                <el-table :data="tableUserDetail.senders" border style="width: 100%;overflow: auto;">
                    <!-- 发端appId	 -->
                    <el-table-column prop="appId" label="发端appId">
                    </el-table-column>
                    <!-- 发端国籍 -->
                    <el-table-column prop="nation" label="发端国籍">
                    </el-table-column>
                    <!-- 发端省份 -->
                    <el-table-column prop="province" label="发端省份">
                    </el-table-column>
                    <!-- 发端城市 -->
                    <el-table-column prop="city" label="发端城市">
                    </el-table-column>
                    <!-- 发端县区 -->
                    <el-table-column prop="county" label="发端县区">
                    </el-table-column>
                    <!-- 发端ip -->
                    <el-table-column prop="ip" label="发端ip">
                    </el-table-column>
                    <!-- 发端设备uid -->
                    <el-table-column prop="uid" label="发端设备uid">
                    </el-table-column>
                    <!-- 发端用户id	 -->
                    <el-table-column prop="userId" label="发端用户id">
                    </el-table-column>
                    <!-- 发端类型	 -->
                    <el-table-column prop="clientType" label="发端类型">
                        <template slot-scope="scope">
                            {{ {
                                0: "安卓", 1: "ios", 2: "tv", 3: "pc", 4: "mac", 5: "h5手机", 6: "h5电脑"
                            }[+scope.row.senderClientType] }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="userTag" label="发端用户标签">
                    </el-table-column>
                    <el-table-column prop="deviceTag" label="发端设备标签">
                    </el-table-column>
                </el-table>


                <!---------------------- 发送端 ----------------------->
                <!-- <h3>发送端信息</h3>
                <el-table :data="tableData" border style="width: 100%">
                    <el-table-column prop="phoneNumber" label="手机号" width="120">
                    </el-table-column>
                    <el-table-column prop="deviceId" label="设备id(cu)" width="100">
                    </el-table-column>
                    <el-table-column prop="IDFA" label="IDFA/AndroidID" width="140">
                    </el-table-column>
                    <el-table-column prop="IpAddress" label="IP地址">
                    </el-table-column>
                    <el-table-column prop="uuid" label="用户uuid">
                    </el-table-column>
                    <el-table-column prop="resourceName" label="渠道名称+appid" width="160">
                    </el-table-column>
                    <el-table-column prop="platformType" label="平台类型">
                    </el-table-column>
                    <el-table-column prop="MacAddress" label="MAC地址">
                    </el-table-column>
                </el-table> -->
                <!-- --------------------风控记录-------------------- -->
                <h3>风控记录</h3>
                <el-table :data="riskRecord" border style="width: 100%">
                    <el-table-column type="index" width="50" />
                    <el-table-column prop="keywords" label="关键词" width="120">
                    </el-table-column>
                    <el-table-column prop="label" label="标签">
                        <!-- fraud-涉诈 yellow-涉黄 terror-涉恐 politics-涉政 -->
                        <template slot-scope="scope">
                            <span v-if="scope.row.label === 'fraud'">涉诈</span>
                            <span v-else-if="scope.row.label === 'yellow'">涉黄</span>
                            <span v-else-if="scope.row.label === 'terror'">涉恐</span>
                            <span v-else-if="scope.row.label === 'politics'">涉政</span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="picUrl" label="命中图片url" width="300">
                        <template slot-scope="scope">
                            <a :href="scope.row.picUrl" target="blank">
                                <el-image :fit="'fit'" :src="scope.row.picUrl">
                                    <div slot="placeholder" class="image-slot">
                                        加载中<span class="dot">...</span>
                                    </div>
                                </el-image></a>
                        </template>
                    </el-table-column>
                    <el-table-column prop="riskResult" label="风控结果">
                        <!--  0-pass 1-review 2-block -->
                    </el-table-column>
                    <el-table-column prop="createTime" label="创建时间"> </el-table-column>
                    <el-table-column prop="updateTime" label="更新时间"> </el-table-column>
                </el-table>
                <!--   ------------------分页组件-------------------- -->
                <div  class="dialog-footer" style="padding: 10px 20px 20px;text-align: right;">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="detailData.current" :page-sizes="[5, 10, 15, 30]" :page-size="detailData.size"
                        layout="total, sizes, prev, pager, next, jumper" :total="detailData.total">
                    </el-pagination>
                </div>
                <h3>抓取图片记录</h3>
                <el-row>
                    <el-col :span="2" v-for="(item, index) in riskImages.resultData" :key="item.id">
                        <el-card :body-style="{ padding: '0px' ,'text-align':'center'}" shadow="hover">
                                <el-image
                                style="height:120px;text-align: center;position: relative; "
                                :src="item.requestJson"
                                fit="fill"
                                :preview-src-list="rearrangedArray(index)"
                                ></el-image>
                                <div>
                                    <time class="time">{{ item.createTime }}</time>
                                </div>
                        </el-card>
                    </el-col>
                </el-row>
                <div  class="dialog-footer" style="padding: 10px 20px 20px;text-align: right;">
                    <el-pagination @size-change="handleImageSizeChange" @current-change="handleImageCurrentChange"
                        :current-page="riskImages.queryData.current" :page-sizes="[10, 20, 30, 40]" :page-size="riskImages.queryData.size"
                        layout="total, sizes, prev, pager, next, jumper" :total="riskImages.queryData.total">
                    </el-pagination>
                </div>
            </el-dialog>
        </basic-container>
    </div>
</template>

<script>
import _ from 'lodash'
import {
    getData,
    getDetail,
    stop,
    ingore,
    riskImagesList,
    getUserDetail
} from "../../api/security/riskResult";
import mapData from "./mapData.json";
import { cloneDeep } from 'lodash';
import Message from '@/components/Message'
export default {
    name: "WebSaaSUserResult",
    created() {
        /**渲染数据 */
        this.loadData();
    },
    data() {
        return {
            cascaderOptions: mapData,
            loading: true,
            //顶部搜索栏配置
            /**搜索表单 */
            searchForm: {
                //场景：0-云镜像 1-云会议
                castFunType: "",
                //投屏内容: 1-镜像 2-推送 3-文件 4-云桌面
                castCxtType: "",
                // 反诈标签：0-否 1-是
                fraudLabel: "",
                // 处理状态：0-正常 1-审核提醒 2-审核阻断 3-系统阻断 4-忽略
                handleState: "",
                //涉政标签：0-否 1-是
                politicsLabel: "",
                //收端类型
                receiverClientType: "",
                //state
                state: "",
                //房间码
                roomCode: "",
                // 收端设备uid
                receiverUid: "",
                // 收端用户id
                receiverUserId: "",
                //发端设备uid
                senderUid: "",
                //发端用户id
                senderUserId: "",
                //taskId
                taskId: "",
                //涉恐标签：0-否 1-是
                terrorLabel: "",
                //涉黄标签：0-否 1-是
                yellowLabel: "",
                //起始时间
                startCreateTime: "",
                //结束时间
                endCreateTime: "",
                //是否查询省份不同的记录，1表示是，0表示否
                differentProvinceFlag:"",
                // 收端省市
                receiverProvince: [],
                // type: null,
                // state: null,
                // roomId: null,
                // uid: null,
                // uuid: null,
                // startMirrorTime: null,
                // startCreateTime: null,
                current: 1,
                size: 10,
                total: ""
            },
            /**风控记录的分页 */
            detailData: {
                current: 1,
                size: 5
            },
            /**场景下拉选择框 */
            useWrCloudSelect: [
                {
                    id: 1,
                    label: "局域网",
                    value: '1'
                },
                {
                    id: 2,
                    label: "公网",
                    value: '2'
                }
            ],
            /** 投屏内容下拉选择框 */
            castCxtTypeSelect: [
                {
                    id: 1,
                    label: "镜像",
                    value: "1"
                },
                {
                    id: 2,
                    label: "推送",
                    value: "2"
                },
                {
                    id: 3,
                    label: "云桌面",
                    value: "3"
                },
                {
                    id: 4,
                    label: "音频文件",
                    value: "4"
                },
                {
                    id: 5,
                    label: "图片文件",
                    value: "5"
                },
                {
                  id: 7,
                  label: "好友分享",
                  value: "7"
                },
                {
                    id: 6,
                    label: "其他",
                    value: "6"
                }
            ],

            formSize: "small",
            form: {
                screenId: "",
                userIdOrPhoneNumber: "",
                recordTime: ""
            },
            //avue-curd的配置
            // 分页
            page: {
                currentPage: 1,
                pageSize: 10
            },

            option: {
                //**操作栏宽度 */
                menuWidth: 200,
                //新增按钮
                addBtn: false,
                //删除按钮
                delBtn: false,
                border: true,
                // 索引
                index: true,
                //索引内容
                indexLabel: "序号",
                expandLevel: 3,
                headerAlign: "center",
                align: "center",
                tree: true,
                labelWidth: 100,
                //关闭操作栏编辑按钮
                editBtn: false,

                //表头显示的内容
                column: [
                    {
                        width: 130,
                        label: "投屏内容",
                        prop: "castCxtType",
                        display: false,
                        // 1-镜像 2-推送 3-云桌面 4-音频文件 5-图片文件 6-其他 7 好友分享
                        dicData: [
                            {
                                label: "镜像",
                                value: "1"
                            },
                            {
                                label: "推送",
                                value: "2"
                            },
                            {
                                label: "云桌面",
                                value: "3"
                            },
                            {
                                label: "音频文件",
                                value: "4"
                            },
                            {
                                label: "图片文件",
                                value: "5"
                            },
                            {
                                label: "其他",
                                value: "6"
                            },
                            {
                              label: "好友分享",
                              value: "7"
                            }
                        ]
                    },
                    {
                        width: 130,
                        label: "投屏方式",
                        prop: "castFunType",
                        display: false,
                        // 1-局域网 2-公网
                        dicData: [
                            {
                                label: "局域网",
                                value: "1"
                            },
                            {
                                label: "公网",
                                value: "2"
                            }
                        ]
                    },
                    {
                        width: 130,
                        label: "反诈标签",
                        prop: "fraudLabel",
                        display: false,
                        //0-否 1-是
                        dicData: [
                            {
                                label: "否",
                                value: "0"
                            },
                            {
                                label: "是",
                                value: "1"
                            }
                        ]
                    },
                    {
                        width: 130,
                        label: "反诈评分等级",
                        prop: "fraudRiskLevel",
                        display: false
                    },
                    {
                        width: 100,
                        label: "反诈风控分数",
                        prop: "fraudRiskScore",
                        display: false
                    },
                    {
                        label: "涉政标签",
                        prop: "politicsLabel",
                        display: false,
                        //0-否 1-是
                        dicData: [
                            {
                                label: "否",
                                value: "0"
                            },
                            {
                                label: "是",
                                value: "1"
                            }
                        ]
                    },
                    {
                        label: "涉政评分等级",
                        prop: "politicsRiskLevel",
                        display: false
                    },

                    {
                        width: 130,
                        label: "涉政风控分数",
                        prop: "politicsRiskScore",
                        display: false
                    },
                    {
                        width: 130,
                        label: "涉恐标签",
                        prop: "terrorLabel",
                        display: false,
                        //0-否 1-是
                        dicData: [
                            {
                                label: "否",
                                value: "0"
                            },
                            {
                                label: "是",
                                value: "1"
                            }
                        ]
                    },
                    {
                        width: 130,
                        label: "涉恐评分等级",
                        prop: "terrorRiskLevel",
                        display: false
                    }, {
                        width: 130,
                        label: "涉恐风控分数",
                        prop: "terrorRiskScore",
                        display: false
                    },
                    {
                        width: 130,
                        label: "涉黄标签",
                        prop: "yellowLabel",
                        display: false,
                        //0-否 1-是
                        dicData: [
                            {
                                label: "否",
                                value: "0"
                            },
                            {
                                label: "是",
                                value: "1"
                            }
                        ]
                    },
                    {
                        width: 130,
                        label: "涉黄评分等级",
                        prop: "yellowRiskLevel",
                        display: false
                    },
                    {
                        width: 130,
                        label: "涉黄风控分数",
                        prop: "yellowRiskScore",
                        display: false
                    },
                    {
                        label: "处理状态",
                        prop: "handleState",
                        display: false,
                        // 0-正常 1-审核提醒 2-审核阻断 3-系统阻断 4-忽略
                        dicData: [
                            {
                                label: "正常",
                                value: "0"
                            },
                            {
                                label: "审核提醒",
                                value: "1"
                            },
                            {
                                label: "审核阻断",
                                value: "2"
                            },
                            {
                                label: "系统阻断",
                                value: "3"
                            },
                            {
                                label: "忽略",
                                value: "4"
                            }
                        ]
                    },

                    {
                        width: 130,
                        label: "收端appId",
                        prop: "receiverAppId",
                        display: false
                    },
                    {
                        width: 130,
                        label: "收端国籍",
                        prop: "receiverNation",
                        display: false
                    },
                    {
                        width: 130,
                        label: "收端省份",
                        prop: "receiverProvince",
                        display: false
                    },
                    {
                        width: 130,
                        label: "收端城市",
                        prop: "receiverCity",
                        display: false
                    },
                    {
                        width: 130,
                        label: "收端县区",
                        prop: "receiverCounty",
                        display: false
                    },
                    {
                        width: 130,
                        label: "收端类型",
                        prop: "receiverClientType",
                        display: false,
                        //0-安卓 1-ios 2-tv 3-pc 4-mac 5-h5手机 6-h5电脑
                        dicData: [
                            {
                                label: "安卓",
                                value: "0"
                            },
                            {
                                label: "ios",
                                value: "1"
                            },
                            {
                                label: "tv",
                                value: "2"
                            },
                            {
                                label: "pc",
                                value: "3"
                            },
                            {
                                label: "mac",
                                value: "4"
                            },
                            {
                                label: "h5手机",
                                value: "5"
                            },
                            {
                                label: "h5电脑",
                                value: "6"
                            }
                        ]
                    },
                    {
                        width: 130,
                        label: "收端ip",
                        prop: "receiverIp",
                        display: false
                    },
                    {
                        width: 130,
                        label: "收端设备uid",
                        prop: "receiverUid",
                        display: false
                    },
                    {
                        width: 130,
                        label: "收端用户id",
                        prop: "receiverUserId",
                        display: false
                    },
                    {
                        width: 130,
                        label: "房间码",
                        prop: "roomCode",
                        display: false
                    },
                    {
                        width: 130,
                        label: "发端appId",
                        prop: "senderAppId",
                        display: false
                    },
                    {
                        width: 130,
                        label: "发端国籍",
                        prop: "senderNation",
                        display: false
                    },
                    {
                        width: 130,
                        label: "发端省份",
                        prop: "senderProvince",
                        display: false
                    },
                    {
                        width: 130,
                        label: "发端城市",
                        prop: "senderCity",
                        display: false
                    },
                    {
                        width: 130,
                        label: "发端县区",
                        prop: "senderCounty",
                        display: false
                    },
                    {
                        width: 130,
                        label: "发端ip",
                        prop: "senderIp",
                        display: false
                    },
                    {
                        width: 130,
                        label: "发端设备uid",
                        prop: "senderUid",
                        display: false
                    },
                    {
                        width: 130,
                        label: "发端用户id",
                        prop: "senderUserId",
                        display: false
                    },
                    {
                        width: 130,
                        label: "厂商",
                        prop: "supplier",
                        display: false,
                        //1-网易 2-即构 3-腾讯
                        dicData: [
                            {
                                label: "腾讯",
                                value: "1"
                            },
                            {
                                label: "即构",
                                value: "5"
                            },
                            {
                                label: "网易",
                                value: "6"
                            },
                            {
                                label: "LeRTC",
                                value: "7"
                            }
                        ]
                    },
                    {
                        width: 200,
                        label: "taskId",
                        prop: "taskId",
                        display: false,
                        overHidden: true,
                    },
                    {
                        width: 130,
                        label: "修改人",
                        prop: "updateBy",
                        display: false
                    },
                    {
                        width: 130,
                        label: "创建人",
                        prop: "createBy",
                        display: false
                    },
                    {
                        width: 130,
                        label: "收端wifi名称",
                        prop: "receiverWifiName",
                    },
                    {
                        width: 130,
                        label: "收端名称",
                        prop: "receiverName",
                    },
                    {
                        width: 190,
                        label: "url",
                        prop: "originalUrl",
                        slot: true,
                        overHidden: true,
                    },
                    {
                        width: 130,
                        label: "发端用户标签",
                        prop: "senderUserTag",
                    },
                    {
                        width: 130,
                        label: "发端设备标签",
                        prop: "senderDeviceTag",
                    },
                    {
                        width: 130,
                        label: "收端用户标签",
                        prop: "receiverUserTag",
                    },
                    {
                        width: 130,
                        label: "收端设备标签",
                        prop: "receiverDeviceTag",
                    },

                    {
                        width: 190,
                        label: "备注",
                        prop: "remark",
                        display: false,
                        slot: true,
                        overHidden: true,
                    },
                    {
                        width: 130,
                        label: "开始时间",
                        prop: "createTime",
                        display: false
                    },
                    {
                        width: 130,
                        label: "结束时间",
                        prop: "endTime",
                    },
                ]
            },
            //表格显示的内容
            list: [],
            //对话框显示与隐藏
            detailDialog: false,

            // //投屏时间
            // screenTime: '',
            // //管控时间
            // controlTime: "",
            //对话框内表格
            tableData: "",
            //对话框内详情数据
            tableUserDetail: {},
            //对话框内分页组件
            currentPage: 1,
            // -------------------------风控记录-------------------------
            riskRecord: [

            ],
            //风险图片相关使用数据
            riskImages:{
                //查询参数
                queryData: {
                    current: 1,
                    size: 10,
                    total: 0
                },
                srcList: [],
                resultData:[],
            }
        };
    },
    computed: {
        /**
         * elementUI 图片组件
         *  z-index	设置图片预览的 z-index
         *  initial-index	图片预览初始图片index
         *  使用组件设置值失效，没找到原因，换种思路重新实现
         */
        // 根据输入的下标动态排列数组
        rearrangedArray() {
            return (index) => {
                const originalArray = this.riskImages.srcList;
                // 判断下标是否合法
                if (index >= 0 && index < originalArray.length) {
                    // 使用 slice 来截取数组并重新拼接
                    //从下标 index 到末尾 ,从头到下标 index 的部分
                    return [
                        ...originalArray.slice(index),
                        ...originalArray.slice(0, index),
                    ];
                }
                // 如果下标不合法，返回原数组
                return originalArray;
            };
        },
    },

    methods: {
        //avue-curd刷新按钮
        refresh() {
            this.handleClear();
            this.loadData();
        },
        removeEmptyProps(obj) {
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop) && obj[prop] === "") {
                    delete obj[prop];
                }
            }
            return obj;
        },
        /**渲染数据 */
        loadData: _.debounce(async function () {
            //模拟分页
            // if (this.searchForm.startCreateTime !== undefined) {
            //     this.searchForm.startCreateTime = this.searchForm.startCreateTime
            //     this.searchForm.endCreateTime = this.searchForm.endCreateTime
            // }
            this.loading = true
            console.log("搜索条件", this.searchForm);
            const params = cloneDeep(this.searchForm);
            const result = this.removeEmptyProps(params);
            try {
                const timeAry = cloneDeep(result.startCreateTime)
                result.startCreateTime = timeAry
                    ? timeAry[0] + " 00:00:00"
                    : "";
                result.endCreateTime = timeAry
                    ? timeAry[1] + " 23:59:59"
                    : "";
            } catch (error) {
                console.log("时间格式化错误");
                console.log(error);
            }
            if (
                result.receiverProvince &&
                Array.isArray(result.receiverProvince) &&
                result.receiverProvince.length
            ) {
                // result.receiverProvince = result.receiverProvince.join("-")
                let data = result.receiverProvince;
                // 判段第一级名称是否有 '市'  city
                // 如果不是，则被province取值

                if (data[0].indexOf("市") !== -1) {
                    result.receiverCity = data[0];
                    result.receiverProvince = "";
                } else {
                    result.receiverCity = data[1] || "";
                    result.receiverProvince = data[0] || "";
                }
            }

            const { data } = await getData(result);
            console.log("渲染数据------", data);
            // if (data.code === 200) {

            // }
            const res = data.data.records;
            this.page.total = data.data.total;
            this.list = res;
            this.loading = false
        }, 500),
        //自定义操作栏详情事件
        async detail(row) {
            console.log("当前选中数据：",JSON.stringify(row));
            this.detailDialog = true;
            //对话框管控数据
            this.tableData = this.list.filter(item => {
                return item.id === row.id;
            });
            //获取详情
            const { data: userDetail } = await getUserDetail(row.id);
            console.log("获取记录详情响应", userDetail);
            this.tableUserDetail = userDetail.data;
            //^ ^-------------/**风控记录的查询 */--------------^ ^
            this.detailData = {
                ...this.detailData,
                taskId: row.taskId
            };
            const { data } = await getDetail(this.detailData);
            console.log("风控记录列表的响应", data);
            const res = data.data.records;
            this.detailData.current = data.data.current;
            this.detailData.size = data.data.size;
            this.detailData.total = data.data.total;
            /**渲染风控记录 */
            this.riskRecord = res;
            //获取风控图片
            //局域网镜像 || 公网云桌面 才有图片
            if(("1" === row.castCxtType && "1" === row.castFunType) || ("3" === row.castCxtType && "2" === row.castFunType) ){
                this.riskImages.queryData.riskId = row.id;
                await this.selectRiskImagesList();
            }
        },
        closeDialog (done) {
            // 关闭弹窗清空相应数据
            this.riskImages.srcList = []
            this.riskImages.resultData = {};
            this.riskImages.queryData = {current: 1, size: 10, total: 0}
            done();
        },
        // 查询封控图片
        async selectRiskImagesList(){
            const { data } = await  riskImagesList(this.riskImages.queryData);
            const records = data.data.records;
            // 循环遍历records并将requestJson加入srcList
            // 提取图片链接
            this.riskImages.srcList = records.map(item => item.requestJson);
            this.riskImages.resultData = records;
            this.riskImages.queryData.current = data.data.current;
            this.riskImages.queryData.size = data.data.size;
            this.riskImages.queryData.total = data.data.total;

        },
        // 复制按钮的提示
        copyTip() {
            Message.success("复制成功")
        },
        async handleImageCurrentChange (val) {
            this.riskImages.queryData.current = val;
            await this.selectRiskImagesList();
        },
        async handleImageSizeChange (val) {
            this.riskImages.queryData.size = val;
            await this.selectRiskImagesList();
        },
        //^ ^--------------风控记录分页-------------^ ^
        //当前页改变
        async handleCurrentChange(val) {
            console.log("当前第几页", val);
            this.detailData.current = val;
            const { data } = await getDetail(this.detailData);
            console.log("风控记录列表分页的响应", data);
            const res = data.data.records;
            this.detailData.current = data.data.current;
            this.detailData.size = data.data.size;
            this.detailData.total = data.data.total;
            res.map(item => {
                if (item.riskResult === "0") {
                    item.riskResult = "返回通过结果";
                } else if (item.riskResult === "1") {
                    item.riskResult = "返回违规结果";
                } else if (item.riskResult === "2") {
                    item.riskResult = "返回疑似结果";
                }
            });
            /**渲染风控记录 */
            this.riskRecord = res;
        },
        async handleSizeChange(val) {
            console.log("每页多少条", val);
            this.detailData.size = val;
            const { data } = await getDetail(this.detailData);
            console.log("风控记录列表分页的响应", data);
            const res = data.data.records;
            this.detailData.current = data.data.current;
            this.detailData.size = data.data.size;
            this.detailData.total = data.data.total;
            res.map(item => {
                if (item.riskResult === "0") {
                    item.riskResult = "返回通过结果";
                } else if (item.riskResult === "1") {
                    item.riskResult = "返回违规结果";
                } else if (item.riskResult === "2") {
                    item.riskResult = "返回疑似结果";
                }
            });
            /**渲染风控记录 */
            this.riskRecord = res;
        },
        /**阻断 */
        async handleStop(id) {
            this.$confirm("是否确认阻断", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(async () => {
                //调用接口
                const res = await stop(id);
                console.log("阻断响应", res);
                if (res.data.code === 200) {
                    /**提示成功 */
                    this.$message({
                        type: "success",
                        message: "阻断成功"
                    });
                    //重新加载数据
                    this.loadData();
                }
            });
        },
        /**忽略 */
        async handleIngore(id) {
            this.$confirm("是否确认忽略", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(async () => {
                //调用接口
                const res = await ingore(id);
                console.log("忽略响应", res);
                /**提示成功 */
                if (res.data.code == 200) {
                    this.$message({
                        type: "success",
                        message: "忽略成功"
                    });
                    //重新加载数据
                    this.loadData();
                }
            });
        },
        //搜索功能的实现
        async handleSearch() {
            this.page.currentPage = 1
            /**调用接口 */
            await this.loadData();
            /**提示用户 */
            this.$message({
                type: "success",
                message: "搜索成功"
            });
            // console.log('搜索的响应', data);
            // this.searchForm = {}
        },
        //清空搜索框
        handleClear() {
            /**搜索表单 */
            this.searchForm = {
                current: 1,
                size: 10,
                total: ""
            };
        },
        //

        // ------------------------对话框内事件----------------------
        //解除管控
        unlockControl(row) {
            this.$confirm(
                "解除临时管控，也会将该账户的风险等级降低为“无风险”，确认解除吗?",
                "解除确认",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }
            )
                .then(() => {
                    console.log("我要解除管控了", row.id);
                    row.isControl = false;
                    this.$message({
                        type: "success",
                        message: "解除成功!"
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消解除"
                    });
                });
        },
        //分页有关事件
        async onLoad(page) {
            this.loadData();
            console.log(page);
        },
        sizeChange(value) {
            this.searchForm.size = value;
            /**渲染数据 */
            this.loadData();
        },
        currentChange(val) {
            this.searchForm.current = val;
            /**渲染数据 */
            this.loadData();
            // this.onLoad(this.page)
            this.$message.success("页码" + val);
        }
    }
};
</script>

<style lang="scss">
.basic-container{
    .time {
        font-size: 13px;
        color: #999;
    }
}


</style>
